var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 17,
  fill: "none",
  viewBox: "0 0 24 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M4.284 16.5H24v-2.667H4.284zm4.355-6.667H24V7.167H8.64zM0 .5v2.667h24V.5z"
})));
export { SvgMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyNCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMjgzODQgMTYuNUgyNFYxMy44MzMzSDQuMjgzODRWMTYuNVpNOC42MzkxMSA5LjgzMzMzSDI0VjcuMTY2NjdIOC42MzkxMVY5LjgzMzMzWk0wIDAuNVYzLjE2NjY3SDI0VjAuNUgwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";